import api from './api';

export const planoService = {
    uploadPlano: async (file) => {
        const fd = new FormData();
        fd.append('image', file);
        const res = await api.post('/planos', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        // La URL viene de Cloudinary (HTTPS seguro)
        return res.data.data;
    },
    getPlanos: async () => {
        const res = await api.get('/planos');
        // Las URLs vienen de Cloudinary (HTTPS seguro)
        return res.data.data;
    },
    deletePlano: async (id) => {
        const res = await api.delete(`/planos/${id}`);
        return res.data;
    },
    activatePlano: async (id) => {
        const res = await api.post(`/planos/${id}/activate`);
        // La URL viene de Cloudinary (HTTPS seguro)
        return res.data.data;
    },
};

export default planoService;